export const copyToclipBoard = (data: string | number) => {
    navigator.clipboard.writeText(data.toString());
}